import React, { useEffect, useState } from 'react';
import './checkbox.css';
export default function Checkbox(props) {
    var _a;
    const [isChecked, setCheckedState] = useState((_a = props.isChecked) !== null && _a !== void 0 ? _a : false);
    useEffect(() => {
        if (props.isChecked !== undefined) {
            setCheckedState(props.isChecked);
        }
    }, [props.isChecked]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: isChecked ? "checkbox box-checked" : "checkbox", onClick: () => {
                setCheckedState(!isChecked);
                props.onTrigger(!isChecked);
            }, onSelect: (event) => event.preventDefault(), role: "radio" },
            React.createElement("div", { className: isChecked ? "checkbox-checked" : "", onSelect: (event) => event.preventDefault() }, isChecked ? '🗸' : '')),
        React.createElement("input", { type: "checkbox", value: isChecked ? "checked" : "unchecked", hidden: true })));
}
